var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.8H7C7.66274 0.8 8.2 1.33726 8.2 2V7C8.2 7.66274 7.66274 8.2 7 8.2H2C1.33726 8.2 0.8 7.66274 0.8 7V2C0.8 1.33726 1.33726 0.8 2 0.8ZM2 11.8H7C7.66274 11.8 8.2 12.3373 8.2 13V18C8.2 18.6627 7.66274 19.2 7 19.2H2C1.33726 19.2 0.8 18.6627 0.8 18V13C0.8 12.3373 1.33726 11.8 2 11.8ZM13 0.8H18C18.6627 0.8 19.2 1.33726 19.2 2V7C19.2 7.66274 18.6627 8.2 18 8.2H13C12.3373 8.2 11.8 7.66274 11.8 7V2C11.8 1.33726 12.3373 0.8 13 0.8ZM13 11.8H18C18.6627 11.8 19.2 12.3373 19.2 13V18C19.2 18.6627 18.6627 19.2 18 19.2H13C12.3373 19.2 11.8 18.6627 11.8 18V13C11.8 12.3373 12.3373 11.8 13 11.8Z",
    stroke: "#939295",
    strokeWidth: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarDashboard);
export default __webpack_public_path__ + "static/media/navbar-dashboard.d396fa93d827cbfbe95fdcb580b4a7b9.svg";
export { ForwardRef as ReactComponent };